(() => {
  const SELECTOR = '.header__inline-menu details.mega-menu';

  const closeMenu = (menu) => {
    menu.classList.remove('open');
    menu.removeAttribute('open');

    const summary = menu.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', 'false');
  };

  const openMenu = (menu) => {
    menu.classList.add('open');
    menu.setAttribute('open', '');

    const summary = menu.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', 'true');
  };

  const bindMenu = (menu) => {
    if (menu.dataset.chromeFixBound === 'true') return;
    menu.dataset.chromeFixBound = 'true';

    closeMenu(menu);

    menu.addEventListener('mouseenter', () => openMenu(menu));
    menu.addEventListener('mouseleave', () => closeMenu(menu));
    menu.addEventListener('focusin', () => openMenu(menu));
    menu.addEventListener('focusout', () => {
      setTimeout(() => {
        if (!menu.contains(document.activeElement)) closeMenu(menu);
      });
    });

    const summary = menu.querySelector('summary');
    if (summary) {
      summary.addEventListener('click', (event) => {
        if (event.target.closest('a')) return;
        event.preventDefault();
      });
    }
  };

  const init = () => {
    document.querySelectorAll(SELECTOR).forEach(bindMenu);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  window.addEventListener('pageshow', init);
})();
